/* eslint-disable */
/// This file is auto generated - do not edit manually
export * as VariantSection from './trans-website-product-productvariants-variantsection';
export * as VariantPickerButton from './trans-website-product-productvariants-variantpickerbutton';

export const MoreVariants = 'Website.Product.ProductVariants.MoreVariants';
export const ShowMoreVariantsButton = 'Website.Product.ProductVariants.ShowMoreVariantsButton';
